import React from 'react';
import { Link } from 'react-router-dom';
import './RecipeCard.css';

function formatTime(mins) {
if (!mins) return null;
if (mins < 60) return `${mins} min`;
const h = Math.floor(mins / 60);
const m = mins % 60;
return m ? `${h} hr ${m} min` : `${h} hr`;
}

export default function RecipeCard({ recipe, featured = false }) {
const imageUrl = recipe.primary_image
? `https://recipe.marumba.com${recipe.primary_image}`
: null;

return (
<Link
to={`/recipe/${recipe.slug}`}
className={`recipe-card ${featured ? 'recipe-card--featured' : ''}`}
>
<div className="recipe-card__image-wrap">
{imageUrl ? (
<img
src={imageUrl}
alt={recipe.title}
className="recipe-card__image"
loading="lazy"
/>
) : (
<div className="recipe-card__image-placeholder">
<span></span>
</div>
)}
<button
className={`recipe-card__heart ${recipe.is_favorite ? 'recipe-card__heart--active' : ''}`}
onClick={e => { e.preventDefault(); /* handled in page */ }}
aria-label="Favorite"
>
<svg width="18" height="18" viewBox="0 0 24 24" fill={recipe.is_favorite ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
</svg>
</button>
</div>

<div className="recipe-card__body">
{recipe.category_name && (
<span className="category-badge">{recipe.category_name}</span>
)}
<h3 className="recipe-card__title">{recipe.title}</h3>
{featured && recipe.description && (
<p className="recipe-card__desc">{recipe.description}</p>
)}
<div className="recipe-card__meta">
{recipe.total_time_mins && (
<span className="recipe-card__meta-item">
<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
</svg>
{formatTime(recipe.total_time_mins)}
</span>
)}
{recipe.servings && (
<span className="recipe-card__meta-item">
<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
<path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
</svg>
{recipe.servings}
</span>
)}
{recipe.difficulty && (
<span className={`recipe-card__difficulty recipe-card__difficulty--${recipe.difficulty}`}>
{recipe.difficulty}
</span>
)}
</div>
</div>
</Link>
);
}
